module.exports = __webpack_public_path__ + "img/qrcode.271c0780.jpg";